<template>
  <div>
    <div class="head"><h3>配送至</h3></div>
    <div class="area">
      <div
        v-for="(item, index) of area"
        :key="index"
        @click="checkArea(item.level)"
        :class="level === item.level ? 'selected' : ''"
        class="area-item"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="area-list">
      <div class="loading">
        <van-loading type="spinner" v-show="areaList.length == 0" />
      </div>
      <ul>
        <li v-for="item of areaList" :key="item.id" @click="select(item)">
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div class="confirm" @click="submitArea"><button>确定</button></div>
  </div>
</template>
<script>
import { getprovince, getcity, getcounty, gettown } from '@/api/address'
import { Loading } from 'vant';


const aLevel = {
  province: 1,
  city: 2,
  county: 3,
  town: 4
}

export default {
  components: {
    [Loading.name]: Loading,
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data () {
    return {
      area: [],
      areaList: [],
      level: 0,
    }
  },
  methods: {
    // 确认表单
    submitArea () {
      this.area.map((item, index) => {
        if (item.name == '请选择') {
          this.area.splice(index, this.area.length)
        }
      })


      let area = {}
      for (const [key, value] of Object.entries(aLevel)) {
        const item = this.area[value - 1]
        if (item) {
          area[`${key}Id`] = item['id']
          area[`${key}Name`] = item['name']
        } else {
          area[`${key}Id`] = 0
          area[`${key}Name`] = ''
        }
      }
      this.$emit('getAreaInfo', area)
    },
    //选中列表
    async select (value) {
      this.area.splice(value.level - 1, this.area.length, value)
      if (value.level < 4) {
        this.level = value.level + 1

        const list = await this.getAreaList(value.level + 1)
        if (list.length !== 0) {
          this.areaList = list
          this.area[value.level] = {
            id: 0,
            name: '请选择',
            pid: 0,
            level: value.level + 1
          }
        } else {
          this.level = value.level
        }
      }
    },
    // 选中地方
    async checkArea (level) {
      this.level = level
      if (this.area[this.level].name === '请选择') {
        this.area[this.level].name = ''
      }
      this.areaList = []
      this.areaList = await this.getAreaList(level)
    },
    //获取地址列表
    async getAreaList (level) {
      let result
      if (level === 1) {
        result = await getprovince()
        return result.data.data.provinceList
      }
      const id = this.area[level - 2].id
      if (level === 2) {
        result = await getcity({ provinceId: id })
        return result.data.data.cityList
      }
      if (level === 3) {
        result = await getcounty({ cityId: id })
        return result.data.data.countyList
      }
      if (level === 4) {
        result = await gettown({ countyId: id })
        return result.data.data.townList
      }
    }
  },
  watch: {
    info: {
      handler: async function (oldV) {
        //地址初始化
        for (const key in aLevel) {
          const type = {
            id: oldV[`${key}Id`],
            name: oldV[`${key}Name`],
            pid: 0,
            level: aLevel[key]
          }
          this.area.splice(aLevel[key], aLevel[key] + 1, type)
        }
        this.level = 1
        this.areaList = await this.getAreaList(1)
        if (this.area[0].id === '') {
          this.area[0] = {
            id: 0,
            name: '请选择',
            pid: 0,
            level: 1
          }
        }
      },
      immediate: true
    }
  },
}
</script>
<style lang="scss" scoped>
.head {
  text-align: center;
}
.area {
  display: flex;
  padding: 0.1rem 0;
  font-size: 0.35rem;
  font-weight: 700;
  .area-item {
    margin: 0 0.2rem;
  }
}
.area-list {
  height: 5.8rem;
  overflow-y: scroll;
  .loading {
    text-align: center;
  }
  li {
    margin: 0.1rem 0.2rem;
  }
}
.selected {
  color: #ff3333;
}
.confirm {
  margin: 0.2rem 0;
  width: 100%;
  text-align: center;
  button {
    border: none;
    background: #ff3333;
    color: #fff;
    width: 2.29rem;
    height: 0.79rem;
    border-radius: 30px;
  }
}
</style>